export enum GameEvent {
  GameStateChanged = 'GameStateChanged',
  PlayMultiplayer = 'PlayMultiplayer',
  CardsUpdated = 'CardsUpdated',
  PlayBot = 'PlayBot',
  PlayPrivate = 'PlayPrivate',
  StartGame = 'StartGame',
  LeaveGame = 'LeaveGame',
  DrawCard = 'DrawCard',
  MakeWord = 'MakeWord',
  InitiateTrade = 'InitiateTrade',
  AcceptTrade = 'AcceptTrade',
  RejectTrade = 'RejectTrade',
  CompleteTrade = 'CompleteTrade',
  CancelTrade = 'CancelTrade',
  SelectOffer = 'SelectOffer',
  AnswerQuestion = 'AnswerQuestion'
}

export enum AppWindowEvent {
  GameLoaded = 'GAME_LOADED',
  ExitGame = 'EXIT_GAME',
  StartGame = 'START_GAME',
  LeaveGame = 'LEAVE_GAME',
  CompleteGame = 'COMPLETE_GAME',
  RestartGame = 'RESTART_GAME'
}
